import { Link } from "react-router-dom";
import './FurnaceReplacement.css';
const FurnaceReplacementAbout = () => {
    return (
        <>
            <div className="Furnace_wepper" style={{ padding: '85px 0' }}>
                <div className="container">
                    <div className="about_hedding">
                        <h2>Should you opt for Furnace Replacement Company in Denver, Colorado?</h2>
                        <p>Furnace replacement is no small decision. A lot of work goes into furnace replacement beginning with the decision to choose between a repair or replacement. If your furnace is more than 12 years old and incurs heavy power bills, then it would be best to opt for furnace replacement. </p>
                        <p>In case, the repair is charge is around or more than 50% of the cost of a new furnace then it will be in your best interest to go for replacement. But, there are more factors into play such as your budget, Furnace replacement cost in Denver etc. </p>
                        <p>This is where our team of experts can help you the most. Give us a call and our experts will do a thorough checkup of the furnace system installed in your home. We give you the breakdown cost for repair and will suggest the best solution for your heating needs. Our work is completely transparent. Our Denver Furnace Replacement Experts will give you the Furnace replacement average cost and the Furnace replacement financing that we offer.</p>

                        <div className="d-flex gap-5">
                            <Link className="same_btn" to="/get-quote-step"> Talk with our experts <img src="images/right-arrow.svg" alt="" /></Link>
                            <Link className="same_btn" to="#">  Shop Now  <img src="images/right-arrow.svg" alt="" /></Link>
                        </div>
                    </div>

                    <div className="furnace_replacement_hedding">
                        <div className="about_hedding mt-5">
                            <h2>Signs That You Should Go For Furnace Replacement Services in Denver, Co</h2>
                            <ul className="Deeming_Frequent_wepper">

                                <div>
                                    <span>Deeming Frequent Repairs</span>
                                    <li> If your furnace deems frequent repair and maintenance, it is high time for a replacement considering other factors</li>
                                </div>
                                <div>
                                    <span>Age of Your Furnace</span>
                                    <li>Furnaces usually work efficiently for up to 15 years with proper maintenance. It is better to opt for an efficient modern system.</li>
                                </div>
                                <div>
                                    <span>Higher Energy Bill Generation</span>
                                    <li> Older, less efficient furnaces will drastically raise power bills. Frequent maintenance can improve efficiency, but that doesn’t always work on older units.</li>
                                </div>


                            </ul>
                        </div>
                    </div>

                </div>

            </div>
        </>
    )
}

export default FurnaceReplacementAbout;